import { call, put } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { Set } from '../../../../ts/models/Set';
import { ChangeExtractTaskPriorityAction } from '../../../../extract/services/ChangeExtractTaskPriorityAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetExtractRefreshPriorityAction } from '../../../actions/spaces/SetExtractRefreshPriorityAction';

export function* handleSetExtractRefreshPriorityAction(action: SetExtractRefreshPriorityAction) {
  try {
    yield call(executeSetExtractRefreshAction, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeSetExtractRefreshAction(items: IExtractTaskInfo[]) {
  return ChangeExtractTaskPriorityAction.execute(Set.fromIdItemArray(items));
}
